import PoliticaPrivacidade from './pages/PoliticaPrivacidade';

function App() {
  return (
    <PoliticaPrivacidade />
  );
}

export default App;
